import apiClient from '../../api/apiClient';

export const fastDomainCheckApi = (data) => {
  return apiClient.post('/partners/oem-partners/fast-domain-check', data);
};

export const getScansApi = (params) => {
  return apiClient.get('/partners/oem-partners/scans/list', { params });
};

export const getOemScansApi = (params) => {
  return apiClient.get('/partners/oem-partners/scans/list', { params });
};